// Fiche close verrouillée sauf pour le boss (Jordan 30.10, retour client) —
// miroir de backend/svp/fiche_close.py, UNE règle pour les 3 fiches.
// Sur l'état ENREGISTRÉ « Clos » : le boss modifie tout ; les rôles de
// ROLES_BLOCS gardent les blocs ouverts de leur fiche (atelier :
// commentaires, sous-traitance, e-mails ; dépannage : commentaires,
// e-mails ; location : observations, e-mails) ; les autres : lecture et
// impression. Réouverture : boss seul.

export const ROLES_BLOCS = {
	atelier: ["admin", "admin_atelier", "responsable_atelier"],
	depannage: ["admin", "admin_depannage", "responsable_depannage"],
	location: ["admin", "admin_atelier", "responsable_atelier"],
}

export const MESSAGE_FICHE_CLOSE =
	"Fiche close : seul le boss peut la modifier ou la rouvrir."

// → { fiche, blocs } : `fiche` = tout le corps est en lecture seule ;
// `blocs` = les blocs ouverts le sont aussi (utilisateur hors du tableau).
export const verrouFicheClose = ({ close, groupes = [], module }) => {
	if (!close || groupes.includes("boss"))
		return { fiche: false, blocs: false }
	const roles = ROLES_BLOCS[module] || []
	return { fiche: true, blocs: !roles.some((g) => groupes.includes(g)) }
}
